import React from "react";
import { makeStyles } from "@material-ui/core";
import CheckboxCustom from './Check';

let useStyles = makeStyles((theme) => ({
    root:{
          // marginTop: 50,
          width: '100%',
          boxShadow: 'rgba(0, 0, 0, 0.06) 0px 0px 20px 0px',
          borderRadius: 10,
          minHeight: 150,
          backgroundColor: 'rbg(255,255,255)',
          padding: '45px 30px',
  
          [theme.breakpoints.down("1100")]: {
              width: '100%',
              minHeight: 'auto',
          },
    },
    titleHead: {
        fontSize: "1.125rem",
        fontWeight: 'bold',
    },
    grid:{
        display:'flex',
        flexWrap:'wrap',
        [theme.breakpoints.down("500")]: {
            width:'100%',
            flexDirection:'column',
            justifyContent:'flex-start',
         
        },
    },
    button: {
        backgroundColor: "#E60001",
        color: "white",
        border: 0,
        minWidth:250,
        height:44,
        marginTop:5,
        borderRadius: "8px",
        // marginRight: 10,
        width: 90,
        height: 44,
        boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
        [theme.breakpoints.down("md")]: {
            width: 120,
            height: 40,
        },
        [theme.breakpoints.down("500")]: {
            width: '98%',
            margin: 'auto',
        },
    },


    gridBtn: {
        [theme.breakpoints.down("500")]: {
            width: '100%',
            margin: "10px 0px",
        },
    },
}))

export default function Index({ keysStock, setkeysStock , apiSubmit }) {

    let classes = useStyles();

    const handelChange = (type, value) => {
            setkeysStock((prev) => ({
                ...prev,
                [type]: value,
            })
            )
        }
    

    return (
        <div className={classes['root']}>
            <div className={classes['head']}>
                <div>
                    <h3 className={classes['titleHead']}>
                        مقایسه کالاهای انتخاب شده بر اساس
                    </h3>
                </div>
                <div className={classes['grid']}>
                    <CheckboxCustom
                        data={{
                            label: 'قیمت میانگین',
                            key: 'final_weighted_average_price'
                        }}
                        keysStock={keysStock}
                        handelChange={handelChange}
                    />
                    <CheckboxCustom
                        data={{
                            label: 'بالاترین قیمت',
                            key: 'maximum_price'
                        }}
                        keysStock={keysStock}
                        handelChange={handelChange}
                    />
                    <CheckboxCustom
                        data={{
                            label: 'پایین ترین قیمت',
                            key: 'minimum_price'
                        }}
                        keysStock={keysStock}
                        handelChange={handelChange}
                    />

                    <CheckboxCustom
                        data={{
                            label: 'قیمت پایه',
                            key: 'offer_base_price'
                        }}
                        keysStock={keysStock}
                        handelChange={handelChange}
                    />
                    <CheckboxCustom
                        data={{
                            label: 'حجم عرضه',
                            key: 'offer_volume'
                        }}
                        keysStock={keysStock}
                        handelChange={handelChange}
                    />
                </div>
                <div className={classes['gridBtn']}>
                    <button
                        className={classes['button']}
                        onClick={() => apiSubmit()}
                    >
                      مقایسه روی نمودار
                    </button>
                </div>
            </div>
        </div>)
}
